var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInformation = function SvgInformation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 0a6 6 0 1 1 0 12A6 6 0 0 1 6 0m0 .719A5.281 5.281 0 1 0 6 11.28 5.281 5.281 0 0 0 6 .72ZM6.075 4.5c.203 0 .369.152.375.342v4.406c0 .195-.168.352-.375.352a.365.365 0 0 1-.375-.342V4.852c0-.195.168-.352.375-.352m0-2.25a.675.675 0 1 1 .03 1.35.675.675 0 0 1-.03-1.35"
  })));
};
export default SvgInformation;